export default "__VITE_ASSET__CrFooTkk__";